import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

import Spinner from "components/library/Spinner";
import AccordionItem from "components/library/AccordionItem";
import Search from "settings/components/Search";
import UserRow from "settings/components/UserRow";
import SettingsWrapper from "settings/components/SettingsWrapper";
import SettingsHeader from "settings/components/SettingsHeader";
import LinkButton from "components/library/LinkButton";
import WithPermissions from "components/library/WithPermissions";
import {
  getGroupMembersAsync,
  getDisabledUsersAsync,
  getGroupsAsync,
} from "settings/actions/users";

import styles from "./Users.css";

class Users extends React.Component {
  constructor(props) {
    super(props);

    this.setFilter = this._setFilter.bind(this);

    this.state = {
      filter: new RegExp(),
    };
  }

  componentDidMount() {
    this.props.getGroupsAsync().then(groups => {
      groups
        // @TODO: The authors group will be removed soon, so this filter can also be removed
        // the "authors" group contains everyone with a byline, incl. people we won't manage through the EDEN admin
        .filter(group => group.name !== "authors")
        .forEach(group => this.props.getGroupMembersAsync(group.name));
    });
    // this.props.getDisabledUsersAsync();
  }

  _setFilter(query) {
    this.setState({ filter: new RegExp("^" + query, "i") });
  }

  accordion(userList, groupName, isOpen = true) {
    const filteredUsers = (userList || []).filter(
      user =>
        this.state.filter.test(user.first_name) ||
        this.state.filter.test(user.last_name)
    );

    if (!filteredUsers.length) return null;

    return (
      <AccordionItem title={groupName} isOpen={isOpen} key={groupName}>
        {userList ? (
          filteredUsers.map(user => <UserRow user={user} key={user.id} />)
        ) : (
          <div className={styles.groupLoading}>
            <Spinner />
          </div>
        )}
      </AccordionItem>
    );
  }

  render() {
    return (
      <SettingsWrapper>
        <Helmet>
          <title>Users</title>
        </Helmet>

        <SettingsHeader title="Users">
          <Search
            className="gtm-find-user"
            onChange={this.setFilter}
            placeholder="Find a user"
          />
          <WithPermissions
            required={["config.feature.user_invite", "users.add_user"]}
          >
            <LinkButton
              type="primary"
              className={styles.addButton}
              to="/settings/users/new"
            >
              + New user
            </LinkButton>
          </WithPermissions>
        </SettingsHeader>

        <div className={styles.accordionItems}>
          {this.props.groups
            .filter(group => group.name !== "authors")
            .map(group =>
              this.accordion(this.props.users[group.name], group.name)
            )}
          {/* this.accordion(this.props.users.disabled, "Disabled users", false) */}
        </div>
      </SettingsWrapper>
    );
  }
}

const mapStateToProps = state => ({
  users: state.settings.users,
  groups: state.settings.users.groups,
});

const mapDispatchToProps = {
  getGroupMembersAsync,
  getDisabledUsersAsync,
  getGroupsAsync,
};

Users.propTypes = {
  users: PropTypes.object,
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    })
  ),
  getGroupMembersAsync: PropTypes.func,
  getDisabledUsersAsync: PropTypes.func,
  getGroupAsync: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Users);
